interface MediaQueryStyleConfig {
	marginTop: number;
	height: number;
}

const defaultStyle: MediaQueryStyleConfig = {
	marginTop: 175,
	height: 175,
};

const landscapeStyle: MediaQueryStyleConfig = {
	...defaultStyle,
	marginTop: 30,
};

const smartphoneStyle: MediaQueryStyleConfig = {
	...defaultStyle,
	marginTop: 10,
	height: 100,
};

const smartphoneLandscapeStyle: MediaQueryStyleConfig = {
	...defaultStyle,
	marginTop: 10,
	height: 0,
};

const mediaQueryStyleConfigs: MediaQueryStyleConfig[] = [
	defaultStyle,
	landscapeStyle,
	smartphoneStyle,
	smartphoneLandscapeStyle,
];

export {
	MediaQueryStyleConfig,
	mediaQueryStyleConfigs,
	defaultStyle
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ResourceCreationPanel/constants.ts